import React from 'react';
import { CheckCircle } from 'lucide-react';

export const OverviewSection = ({ isSuperAdmin, hospitalName }) => (
  isSuperAdmin ? (
    <>
      <h3 className="text-lg font-semibold mb-3">Welcome to the Acacia Insurance System</h3>
      <p className="mb-4">As a <span className="font-semibold text-green-600">System Administrator</span>, you have full access to manage the entire system including hospitals, families, members, price lists, and claims.</p>

      <div className="bg-blue-50 border border-blue-200 rounded-lg p-4 mb-4">
        <h4 className="font-semibold text-blue-900 mb-2 flex items-center gap-2">
          <CheckCircle className="w-4 h-4" />
          Your Capabilities
        </h4>
        <ul className="list-disc list-inside space-y-1 text-sm text-blue-800">
          <li>Manage all hospitals and their users</li>
          <li>Add/edit/delete families and members</li>
          <li>Manage price lists for all hospitals</li>
          <li>Add deposits to hospitals</li>
          <li>View and manage all claims across hospitals</li>
          <li>Mark claims as paid or void them</li>
          <li>Bulk upload families and price lists</li>
          <li>Suspend/unsuspend families and members</li>
          <li>View activity logs and system statistics</li>
        </ul>
      </div>

      <h4 className="font-semibold mb-2">Quick Start Workflow:</h4>
      <ol className="list-decimal list-inside space-y-2 text-sm">
        <li><strong>Set up hospitals</strong>: Navigate to Admin Panel → Hospitals tab to add hospital details</li>
        <li><strong>Add families</strong>: Go to Admin Panel → Families tab to add family information and allotments</li>
        <li><strong>Add members</strong>: In the Members tab, add family members linked to their families</li>
        <li><strong>Configure price lists</strong>: Set up medical services and costs for each hospital in Price Lists tab</li>
        <li><strong>Add deposits</strong>: Add initial deposits to hospitals in the Deposits tab</li>
        <li><strong>Monitor claims</strong>: View and manage claims from all hospitals on the main dashboard</li>
      </ol>
    </>
  ) : (
    <>
      <h3 className="text-lg font-semibold mb-3">Welcome to the Acacia Insurance System</h3>
      <p className="mb-4">As a <span className="font-semibold text-green-600">Hospital Admin</span> for <span className="font-semibold">{hospitalName}</span>, you can manage claims and view patient information.</p>

      <div className="bg-green-50 border border-green-200 rounded-lg p-4 mb-4">
        <h4 className="font-semibold text-green-900 mb-2 flex items-center gap-2">
          <CheckCircle className="w-4 h-4" />
          Your Capabilities
        </h4>
        <ul className="list-disc list-inside space-y-1 text-sm text-green-800">
          <li>Search for patients by serial number or family ID</li>
          <li>Submit claims for medical services</li>
          <li>View all claims for your hospital</li>
          <li>Print claim receipts</li>
          <li>View hospital balance</li>
          <li>View available price list items</li>
        </ul>
      </div>

      <h4 className="font-semibold mb-2">Quick Start Workflow:</h4>
      <ol className="list-decimal list-inside space-y-2 text-sm">
        <li><strong>Search patient</strong>: Use the Patient Search section to find a patient by serial number or family ID</li>
        <li><strong>Select patient</strong>: Choose the specific family member who received treatment</li>
        <li><strong>Add claim items</strong>: Search and add medical services from your price list</li>
        <li><strong>Submit claim</strong>: Review total cost and submit the claim</li>
        <li><strong>Print receipt</strong>: Use the print button to generate a claim receipt</li>
      </ol>
    </>
  )
);
